import * as React from 'react';

import styles from './Unauthorized.module.scss';
import { Logo } from './Logo';
import { useOktaAuth } from '@okta/okta-react';
import { Link } from '@fluentui/react';
import { useEffect, useState } from 'react';
import { resolveUsername } from '../../okta';

declare const healConfig: any;

export const Unauthorized = ({error}: {error?: Error}) => {
  const { oktaAuth, authState } = useOktaAuth();
  const [email, setEmail] = useState('');

  useEffect(() => {
    if (authState && authState.isAuthenticated && authState.accessToken) {
      setEmail(resolveUsername(authState.accessToken));
    }
  }, [authState]);

  const logout = async () => {
    // Read idToken before local session is cleared
    const idToken = authState?.idToken?.idToken;

    // Clear local session
    oktaAuth.tokenManager.clear();

    // Clear remote session
    window.location.href = `${healConfig.oktaIssuer}/v1/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${window.location.origin}/`;
  };

  const oktaHome = new URL('/app/UserHome', healConfig.oktaIssuer).href;

  return (
    <div className={styles.container}>
      <Logo />
      <h1>You are not authorized to access this page.</h1>
      <p>
        If you think this is an error, please send an email to <Link href="mailto:support@heal.com">support@heal.com</Link>
        <br />
        <br />
        You can <Link href="https://heal.com">visit our website</Link> or navigate to our{' '}
        <Link href={healConfig.env === 'prd' ? 'https://my.heal.com' : 'https://my.' + healConfig.env + '.heal.com'}>patient portal</Link>.
        <br />
        <br />
        {email && (
          <span>
            You can also <Link onClick={logout}>sign out</Link> of this account (<strong>{email}</strong>)
          </span>
        )}
        {error && (
          <span>
            <br />
            <br />
            <strong>Error: </strong> {error.message}
            <br/>
            Check <Link href={oktaHome}>Okta</Link>. You may be logged in with another account that does not have access to this application.
          </span>
        )}
      </p>
    </div>
  );
};
